module.exports = __webpack_public_path__ + "img/404.7cf62762.png";